<div class="agreement-item"
  [ngClass]="{'regular-event': latestAgreementChange.event_interval !== 'one-time', 'special-event': latestAgreementChange.event_interval === 'one-time' && !agreement.is_private, 'private-event': agreement.is_private}">
  <div class="agreement-item-data">
    <div class="w-100">
      <p class="no-m">
        <strong class="agreement-item-title">{{ translateGameType() }}</strong><br>
        <span *ngIf="displayVenueName">
          <span>At: </span>
          <a
          href="/venues/{{ latestAgreementChange?.kt_venue_id }}/details"
          target="_blank">{{ latestAgreementChange?.venue_name }}</a>
        </span>
      </p>
      <div class="agreement-item-details">
        <p>{{ formatEventSchedule() }}
        </p>
        <p *ngIf="latestAgreementChange.event_interval !== 'one-time'">
          <span class="text-muted">|</span> From <b>{{ agreement.first_event | date:'MMMM dd, yyyy' }}</b>
          <span *ngIf="agreement.last_event"> Until </span>
          <b>{{ agreement.last_event | date:'MMMM dd, yyyy' }}</b>
        </p>
      </div>
      <div class="badges">
        <div class="badge badge-success" *ngIf="agreement.active">
          <i title="Active" class="material-icons text-green-400">done_all</i>
          <span>Active</span>
        </div>
        <div class="badge badge-danger" *ngIf="!agreement.active">
          <i title="Active" class="material-icons">block</i>
          <span>Deactivated</span>
        </div>
        <div class="badge badge-info">
          <i class="material-icons" *ngIf="latestAgreementChange?.is_online">cast</i>
          <i class="material-icons" *ngIf="!latestAgreementChange?.is_online">store</i>
          <span>{{ latestAgreementChange?.is_online ? 'Online Event': 'In-Person Event' }}</span>
        </div>
        <div class="badge badge-warning">
          <i *ngIf="latestAgreementChange?.is_ihh" class="material-icons">person_off</i>
          <i *ngIf="!latestAgreementChange?.is_ihh" class="material-icons">person</i>
          <span>{{ latestAgreementChange?.is_ihh ? 'IHH': 'Fully Hosted' }}</span>
        </div>
      </div>
      <div *ngIf="displayClientName" class="sm-mt">
        <span>Client: </span>
        <a
        href="/clients/{{ agreement.client_id }}/details"
        target="_blank">{{ agreement.client_name }}</a>
      </div>
      <div *ngIf="futureAgreementChanges.length > 0">
        <div class="future-change" *ngFor="let item of futureAgreementChanges">
          <div class="future-change-header">
          <i class="material-icons future-change-icon">schedule</i>
          <span class="future-change-title">
            Upcoming Change on
            <b>{{ item.effective_date | date:'MMMM dd, yyyy' }}</b>
          </span>
          </div>
          <div class="future-change-details">
            <div *ngFor="let change of getAgreementDifferences(item)"
              class="future-change-row">
              <span class="change-field">{{ formatAgreementChangeFieldName(change.field) }}:</span>
              <span class="change-value">{{ formatAgreementChangeFieldValue(change.field, change.value) }}</span>
            </div>
          </div>
          <div class="flex justify-end">
            <button class="undo-change-button" (click)="setAgreementChangeToUndo(item)" [disabled]="isSavingModal">
                <i class="material-icons">undo</i>
              Undo Change
            </button>
          </div>
        </div>
      </div>
    </div>
  <div class="agreement-item-actions">
    <div class="dropdown-menu-wrapper">
      <button class="dropdown-toggle" (click)="toggleDropdown($event)">
        <i class="material-icons">more_vert</i>
      </button>
      <div class="dropdown-menu" [class.show]="dropdownOpen === true">
        <button class="dropdown-item" (click)="showAgreementHistoryModal = true;">
          <i class="material-icons">history</i>
          History
        </button>
        <button class="dropdown-item" (click)="toggleAgreementStatus()">
          <i class="material-icons">{{ agreement.active ? 'block' : 'check_circle' }}</i>
          {{ agreement.active ? 'Deactivate' : 'Reactivate' }}
        </button>
        <button class="dropdown-item" (click)="startEditAgreement()">
          <i class="material-icons">edit</i>
          Edit
        </button>
        <button class="dropdown-item delete-item" (click)="deleteAgreement(agreement)">
          <i class="material-icons">delete</i>
          Delete
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL CONTENTS -->

<ng-template #toogleAgreementStatusContent>
  <p>
    <span *ngIf="editedAgreement.active">This action will immediately remove this event from the schedule and the Where to Play page.</span>
    <span *ngIf="!editedAgreement.active">This action will reinstate this event on the schedule and the Where to Play page.</span>
  </p>

  <div *ngIf="!editedAgreement.active" class="input-group">
    <label>
      <input
        type="checkbox"
        [(ngModel)]="showLastEventInput"
        (ngModelChange)="showLastEventInput ? null : (editedAgreement.last_event = null)"
      />
      Set a last event date for this event
    </label>
  </div>

  <div *ngIf="showLastEventInput" class="input-group">
    <label for="end">Last Event Date</label>
    <input type="date" [(ngModel)]="editedAgreement.last_event" id="end" class="textbox p-10" />
  </div>

  <p class="error-message" *ngIf="getLastEventValidationMessage()">
    <span>{{ getLastEventValidationMessage() }}</span>
  </p>

  <p class="error-message" *ngIf="modalErrorMessage">{{ modalErrorMessage }}</p>
</ng-template>

<ng-template #agreementEditOptionContent>
  <p>Please select the purpose for your edit so you can be directed to the correct form!</p>

  <div class="edit-option-container">
    <label class="edit-option edit-option-details">
      <input type="radio" name="editPurpose" value="details" [(ngModel)]="selectedEditPurpose">
      <div class="edit-option-content">
        <i class="material-icons">info</i>
        <span>Change event details</span>
      </div>
    </label>

    <label class="edit-option edit-option-dates">
      <input type="radio" name="editPurpose" value="dates" [(ngModel)]="selectedEditPurpose">
      <div class="edit-option-content">
        <i class="material-icons">event</i>
        <span>I need to adjust the dates for this event</span>
      </div>
    </label>
  </div>
</ng-template>

<ng-template #agreementEditContent>
  <div *ngIf="selectedEditPurpose === 'details'">

    <div class="input-group">
      <div class="input-group" *ngIf="latestAgreementChange.event_interval !== 'one-time'">
        <label for="effectivityDate">Changes Effective Starting On <span class="required-indicator">*</span></label>
        <input type="date" [(ngModel)]="editedAgreementDetails.effective_date" [formControl]="dateControl" id="effectivityDate"
               class="textbox p-10" [min]="getMinEffectiveDate()">
        <p *ngIf="dateControl.errors && dateControl.errors['invalidDate']" class="error-message">Please choose the date on which the first effected event will occur. For recurring events where the day of the week is changing, select the earlier of:<br>- The original event date or <br>- The new event date after after the day change</p>
      </div>

      <label>Game Type<span class="required-indicator"> *</span></label>
      <div class="radio-group">
        <label class="radio-option">
          <input
            type="radio" name="gameType" value="trivia"
            [(ngModel)]="editedAgreementDetails.game_type">
          <span>King Trivia</span>
        </label>
        <label class="radio-option">
          <input
            type="radio" name="gameType" value="slam"
            [(ngModel)]="editedAgreementDetails.game_type">
          <span>Survey Slam</span>
        </label>
        <label class="radio-option">
          <input
            type="radio" name="gameType" value="bingo"
            [(ngModel)]="editedAgreementDetails.game_type">
          <span>Music Bingo</span>
        </label>
      </div>
    </div>

    <div class="input-group">
      <label>
        <input type="checkbox" [(ngModel)]="editedAgreementDetails.is_online" class="checkbox-input">
        Online Event
      </label>
    </div>

    <div class="input-group">
      <label>
        <input type="checkbox" [(ngModel)]="editedAgreementDetails.is_ihh" class="checkbox-input">
        In-House Hosted
      </label>
    </div>

    <!-- <div class="input-group">
      <label>
        <input type="checkbox" [(ngModel)]="editedAgreement.is_private" class="checkbox-input">
        Private Event
      </label>
    </div> -->

    <!-- event interval -->
    <!-- <div class="input-group">
      <label for="eventInterval">Event Interval <span class="required-indicator">*</span></label>
      <select
      [(ngModel)]="editedAgreementDetails.event_interval"
      (ngModelChange)="onEventIntervalChange($event)"
      id="eventInterval"
      class="textbox p-10">
        <option value="one-time">One-Time</option>
        <option value="weekly">Weekly</option>
        <option value="biweekly">Bi-Weekly (Every 2 weeks)</option>
        <option value="monthly-first">Monthly (1st week)</option>
        <option value="monthly-second">Monthly (2nd week)</option>
        <option value="monthly-third">Monthly (3rd week)</option>
        <option value="monthly-fourth">Monthly (4th week)</option>
        <option value="monthly-last">Monthly (Last week)</option>
      </select>
    </div> -->

    <div class="input-group" *ngIf="editedAgreementDetails.event_interval === 'one-time'">
      <label for="eventName">Event Name</label>
      <input type="text" [(ngModel)]="editedAgreementDetails.event_name" id="eventName"
             class="textbox p-10" placeholder="Enter a name for this one-time event">
    </div>

    <div class="input-group" *ngIf="editedAgreementDetails.event_interval === 'one-time'">
      <label for="eventName">Event Name</label>
      <input type="text" [(ngModel)]="editedAgreementDetails.event_name" id="eventName"
             class="textbox p-10" placeholder="Enter a name for this one-time event">
    </div>

    <div class="input-group">
      <label class="md-mt">Event Schedule <span class="required-indicator">*</span></label>
      <div class="scheduler-container">

        <div class="scheduler-row" *ngIf="editedAgreementDetails.event_interval === 'one-time'">
          <span class="scheduler-label">Date</span>
          <input type="date" [min]="getTodayDate()" [(ngModel)]="editedAgreementDetails.event_date" class="scheduler-select">
          <span class="scheduler-label">at</span>
          <input type="time" [(ngModel)]="editedAgreementDetails.event_time" class="scheduler-select">
        </div>
        <div class="scheduler-row" *ngIf="editedAgreementDetails.event_interval !== 'one-time'">
          <span class="scheduler-label">On</span>
          <select [(ngModel)]="editedAgreementDetails.day_of_week" (change)="onDayOfWeekChange()" class="scheduler-select">
            <option [ngValue]="1">Sundays</option>
            <option [ngValue]="2">Mondays</option>
            <option [ngValue]="3">Tuesdays</option>
            <option [ngValue]="4">Wednesdays</option>
            <option [ngValue]="5">Thursdays</option>
            <option [ngValue]="6">Fridays</option>
            <option [ngValue]="7">Saturdays</option>
          </select>
          <span class="scheduler-label">at</span>
          <input type="time" [(ngModel)]="editedAgreementDetails.event_time" class="scheduler-select">
        </div>
      </div>
    </div>

    <!-- rate -->
    <!-- <div class="input-group">
      <label for="rate">Rate <span class="required-indicator">*</span></label>
      <input type="number" [(ngModel)]="editedAgreementDetails.rate" id="rate"
             class="textbox p-10" placeholder="$">
    </div> -->
  </div>

  <div *ngIf="selectedEditPurpose === 'dates'">
    <div class="input-group">
      <label for="contractDate">Contract Date <span class="required-indicator">*</span></label>
      <input type="date" [(ngModel)]="editedAgreement.contract_date" id="contractDate"
             class="textbox p-10">
    </div>

    <div class="input-group">
      <label for="firstEvent">First Event Date <span class="required-indicator">*</span></label>
      <input type="date" [(ngModel)]="editedAgreement.first_event" id="firstEvent"
             class="textbox p-10">
    </div>

    <div class="input-group">
      <label for="lastEvent">Last Event Date</label>
      <input type="date" [(ngModel)]="editedAgreement.last_event" id="lastEvent"
             class="textbox p-10">
    </div>
  </div>

  <div *ngIf="selectedEditPurpose === 'media'">
    <h4>Edit Event Media</h4>
    <p>Media editing functionality coming soon...</p>
  </div>

  <p class="error-message" *ngIf="modalErrorMessage">{{ modalErrorMessage }}</p>
</ng-template>

<!-- Delete Confirmation Modal Content -->
<ng-template #deleteAgreementContent>
  <div class="input-group">
    <p>Are you sure you want to permanently delete this agreement?</p>
    <div class="agreement-summary">
      <strong>{{ translateGameType() }}</strong>
      <p>{{ formatEventSchedule() }}</p>
      <p class="text-muted">for {{ latestAgreementChange?.venue_name }}</p>
    </div>
    <div class="warning-message">
      <i class="material-icons">warning</i>
      <span>This action cannot be undone.</span>
    </div>
  </div>
  <p class="error-message" *ngIf="modalErrorMessage">{{ modalErrorMessage }}</p>
</ng-template>

<!-- Confirm undo agreement change -->
<ng-template #confirmUndoAgreementChangeContent>
  <div class="input-group">
    <p>
      <strong>Are you sure you want to undo the change effective on {{ agreementChangeToUndo?.effective_date | date:'MMMM dd, yyyy' }}?</strong>
    </p>

    <div class="warning-message">
      <i class="material-icons">warning</i>
      <span>This action cannot be undone.</span>
    </div>
  </div>
  <p class="error-message" *ngIf="modalErrorMessage">{{ modalErrorMessage }}</p>
</ng-template>

<!-- Agreement History Modal Content -->
<ng-template #agreementHistoryContent>
  <ul class="agreement-timeline">
    <li *ngIf="agreement.contract_date && agreement.contract_date !== '0000-00-00'">
      <strong>Contract Signed:</strong> {{ agreement.contract_date | date:'MMMM dd, yyyy' }}
    </li>
    <li>
      <strong *ngIf="firstAgreementChange?.event_interval !== 'one-time'">First Event: {{ agreement.first_event | date:'MMMM dd, yyyy' }}</strong><br>
      <span>Venue: {{ firstAgreementChange?.venue_name }}</span><br>
      <span *ngIf="firstAgreementChange?.event_interval !== 'one-time'">Event Interval: {{ firstAgreementChange.event_interval }}<br></span>
      <span *ngIf="firstAgreementChange?.event_interval !== 'one-time'">{{ formatAgreementChangeFieldValue('day_of_week', firstAgreementChange.day_of_week) }}s at {{ formatAgreementChangeFieldValue('event_time', firstAgreementChange.event_time) }}<br></span>
      <span *ngIf="firstAgreementChange?.event_interval === 'one-time'">Event Date: {{ formatAgreementChangeFieldValue('event_date', firstAgreementChange.event_date) }} at {{ formatAgreementChangeFieldValue('event_time', firstAgreementChange.event_time) }}</span>
      <span>{{ firstAgreementChange?.is_online ? 'Online Event' : 'In-Person Event' }}</span><br>
      <span>{{ firstAgreementChange?.is_ihh ? 'In-House Hosted' : 'Fully Hosted' }}</span><br>
    </li>
    <li *ngFor="let change of getAgreementChangesMinusInitial(); let i = index;">
      <strong>Change Effective On: {{change.effective_date | date:'MMMM dd, yyyy'}}</strong><br>
      <span *ngIf="change.kt_venue_id !== agreement.agreement_changes[i].kt_venue_id">Venue: {{ change.venue_name }}<br></span>
      <span *ngIf="change.game_type !== agreement.agreement_changes[i].game_type">{{ translateGameType(change.game_type) }}<br></span>
      <span *ngIf="change.is_online !== agreement.agreement_changes[i].is_online">{{ change.is_online ? 'Online Event' : 'In-Person Event' }}<br></span>
      <span *ngIf="change.is_ihh !== agreement.agreement_changes[i].is_ihh">{{ change.is_ihh ? 'In-House Hosted' : 'Fully Hosted' }}<br></span>
      <span *ngIf="change.event_interval !== agreement.agreement_changes[i].event_interval">{{ change.event_interval }}<br></span>
      <span *ngIf="change.event_name !== agreement.agreement_changes[i].event_name && change.event_interval === 'one-time'">{{ change.event_name }}<br></span>
      <span *ngIf="change.day_of_week !== agreement.agreement_changes[i].day_of_week && change.event_interval !== 'one-time'">{{ formatAgreementChangeFieldValue('day_of_week', change.day_of_week) }}s<br></span>
      <span *ngIf="change.event_time !== agreement.agreement_changes[i].event_time && change.event_interval !== 'one-time'">{{ formatAgreementChangeFieldValue('event_time', change.event_time) }}<br></span>
    </li>
    <li *ngIf="agreement.last_event && agreement.last_event !== '0000-00-00'">
      <strong>Last Event: {{ agreement.last_event | date:'MMMM dd, yyyy' }}</strong>
    </li>
  </ul>
</ng-template>

<!-- MODALS -->
 <app-basic-modal *ngIf="showAgreementToggleStatusModal" [template]="toogleAgreementStatusContent" [hideX]="true"
  [staticBackground]="false" [title]="agreementToggleStatusModalTitle" [cancel]="'Close'"
  (doCancel)="showAgreementToggleStatusModal = false" [action]="isSavingModal ? 'Saving...' : 'Save'"
  (doAction)="updateAgreementStatus()" [disabled]="isSavingModal">
</app-basic-modal>

<app-basic-modal *ngIf="showAgreementEditOptionModal" [template]="agreementEditOptionContent" [hideX]="true"
  [staticBackground]="false" [title]="'Edit Agreement?'" [cancel]="'Cancel'"
  (doCancel)="showAgreementEditOptionModal = false" [action]="'Continue'" (doAction)="showAgreementEdit()">
</app-basic-modal>

<app-basic-modal *ngIf="showAgreementEditModal" [template]="agreementEditContent" [hideX]="true"
  [staticBackground]="false" [title]="'Edit Event Details'" [cancel]="'Cancel'"
  (doCancel)="cancelAgreementEdit()" [action]="isSavingModal ? 'Saving...' : 'Save Changes'"
  (doAction)="newAgreementChange()" [disabled]="isSavingModal || disableModalSaveButton">
</app-basic-modal>

<app-basic-modal *ngIf="showAgreementDeleteModal" [template]="deleteAgreementContent" [hideX]="true"
  [staticBackground]="false" [title]="'Delete Agreement'" [cancel]="'Cancel'"
  (doCancel)="cancelDeleteAgreement()" [action]="isSavingModal ? 'Deleting...' : 'Delete Agreement'"
  (doAction)="confirmDeleteAgreement()" [disabled]="isSavingModal">
</app-basic-modal>

<app-basic-modal *ngIf="showConfirmUndoAgreementChangeModal" [template]="confirmUndoAgreementChangeContent" [hideX]="true"
  [staticBackground]="false" [title]="'Confirm Undo Change'" [cancel]="'Cancel'"
  (doCancel)="showConfirmUndoAgreementChangeModal = false" [action]="isSavingModal ? 'Reverting...' : 'Undo Change'"
  (doAction)="undoAgreementChange()" [disabled]="isSavingModal">
</app-basic-modal>

<app-basic-modal *ngIf="showAgreementHistoryModal" [template]="agreementHistoryContent" [hideX]="true"
  [staticBackground]="false" [title]="'Agreement History'" [cancel]="'Close'"
  (doCancel)="showAgreementHistoryModal = false">
</app-basic-modal>
